import React, { PureComponent } from "react";
import Image from "next/image";
import classNames from "classnames";

import "./page-heading.scss";

// Light page top (docs/hero-redesign-plan.md, direction A): the title, one
// line under it, and an `actions` slot that sits to the right on wide
// screens. `children` go below the title row (filters, a search box).
// `showImage` + `src` draws a wide cover under the title (blog posts).
class PageHeading extends PureComponent {
  render() {
    const { title, src, alt, subHeader, showImage, actions, children, size } = this.props;
    const withImage = Boolean(showImage && src);

    return (
      <header
        className={classNames("page-heading", {
          "page-heading--image": withImage,
          "page-heading--large": size === "large",
        })}
      >
        <div className="page-heading__inner">
          <div className="page-heading__row">
            <div className="page-heading__text">
              <h1 className="page-heading__copy">{title}</h1>
              {subHeader && <p className="page-heading__sub-heading">{subHeader}</p>}
            </div>
            {actions && <div className="page-heading__actions">{actions}</div>}
          </div>
          {children && <div className="page-heading__extra">{children}</div>}
          {withImage && (
            <span className="page-heading__img-cont">
              <Image src={src} alt={alt || ""} layout="fill" priority={true} className="page-heading__img" />
            </span>
          )}
        </div>
      </header>
    );
  }
}

export default PageHeading;
